import React from 'react';
import './Home.css';

const screenshots = [
  { src: '/ANG/ANG_screenpage%201%20(3).png', caption: 'Join the Adventure' },
  { src: '/ANG/ANG_screenpage%202%20(4).png', caption: 'Master Your Discipline' },
  { src: '/ANG/ANG_screenpage%203%20(3).png', caption: 'Choose Your Class' },
  { src: '/ANG/ANG_screenpage%204%20(3).png', caption: 'Community Reviews' },
  { src: '/ANG/ANG_screenpage%205%20(3).png', caption: 'Level Up' },
  { src: '/ANG/ANG_screenpage%206%20(3).png', caption: 'Climb the Rankings' },
];

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-icon-container">
              <img src="/new-icon-fxp.png" alt="Flow XP Icon" className="hero-icon" />
            </div>
            <h1 className="hero-title">
              Welcome to <span className="highlight">Flow XP</span>
            </h1>
            <p className="hero-subtitle">
              The ultimate gamified sports app for urban athletes
            </p>
            <p className="hero-description">
              Breaking, Freestyle Football, Street Workout — Level up your skills,
              join the community, and unlock exclusive content
            </p>
            <div className="hero-buttons">
              <a href="#download" className="btn btn-primary">
                <span>Download Now</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                </svg>
              </a>
              <a href="/support" className="btn btn-secondary">Get Support</a>
            </div>
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section className="screenshots-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Discover Flow XP</h2>
          </div>
        </div>
        <div className="screenshots-track-wrapper">
          <div className="screenshots-track">
            {[...screenshots, ...screenshots].map((s, i) => (
              <div
                className="screenshot-card"
                key={i}
                aria-hidden={i >= screenshots.length ? true : undefined}
              >
                <img src={s.src} alt={s.caption} />
                <div className="screenshot-caption">{s.caption}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section id="download" className="download">
        <div className="container">
          <div className="section-header centered">
            <h2 className="section-title">Download Flow XP</h2>
          </div>
          <p className="download-text">Available on iOS & Android — Start your journey today!</p>
          <div className="download-buttons">
            <a
              href="https://apps.apple.com/app/flow-xp/id6778499011"
              target="_blank"
              rel="noopener noreferrer"
              className="store-button"
            >
              <div className="store-btn apple">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <div className="store-btn-text">
                  <span className="store-btn-sub">Download on the</span>
                  <span className="store-btn-main">App Store</span>
                </div>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.baou.flwmobile"
              target="_blank"
              rel="noopener noreferrer"
              className="store-button"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-card">
            <h2 className="section-title">Need Help?</h2>
            <p>Contact us at <a href="mailto:flowledgeteam@gmail.com" className="email-link">flowledgeteam@gmail.com</a></p>
            <a href="/support" className="btn btn-primary">
              <span>Visit Support Page</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
